import { Head } from "@/components/core/index";
import type { NextPage } from "next";
import { Container, Heading, Button, VStack, Box, Image, Text } from "@chakra-ui/react";
import { useRouter } from "next/dist/client/router";
import { ArrowForwardIcon } from "@chakra-ui/icons";

const Home: NextPage = () => {
  const router = useRouter();

  const handleRedirectNewContact = () => {
    router.push("/contact/new");
  };

  const handleRedirectToEstimate = () => {
    router.push("/estimate/new");
  };

  return (
    <>
      <Head />
      <Container textAlign="center" maxW="md">
        <VStack width="full" textAlign="center" paddingTop={4} paddingBottom={8}>
          <Image alt="logo-brand" src="/logo-brand.png" width="67.5" height="98" />
          <Heading paddingTop={2} as="h1" fontSize="3xl">
            Outils numériques
          </Heading>
        </VStack>
        <VStack spacing={6}>
          <Box w="full">
            <Button rightIcon={<ArrowForwardIcon />} onClick={handleRedirectNewContact} colorScheme="blue" w="full">
              <Text>Nouveau client</Text>
            </Button>
          </Box>
          <Box w="full">
            <Button rightIcon={<ArrowForwardIcon />} onClick={handleRedirectToEstimate} colorScheme="blue" w="full">
              <Text>Génération de devis</Text>
            </Button>
          </Box>
        </VStack>
      </Container>
    </>
  );
};

export default Home;
